<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout row wrap v-if="!loading">
            <v-flex xs12 v-if="data&&!ecMode" :class="[hideKpi ? 'md12' : 'md10']">
                <vue-plotly :white-mode="whiteMode" show-export :data="data" :layout="layout" :options="{}" ref="plotly"/>
            </v-flex>
            <v-flex xs12 v-if="ecMode&&ecConfig" :class="[hideKpi ? 'md12' : 'md10']">
                <vue-echart :white-mode="whiteMode" :config="ecConfig" :height="490"></vue-echart>
            </v-flex>
            <v-flex xs12 md2 v-if="data&&!hideKpi">
                <v-layout row wrap>
                    <v-flex xs12 v-if="totalSavingSum">
                        <value-box :white-mode="whiteMode" :value="savingPercentage" unit="%" :title="'Energy Savings'|translate"></value-box>
                    </v-flex>
                    <v-flex xs12>
                        <value-box :white-mode="whiteMode" :value="totalSavingSum" unit="kWh" :title="'Energy Savings'|translate" has-comma></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="showCalc">
                        <value-box :white-mode="whiteMode" :value="calcEquation" bypass unit="" :title="'Baseline'|translate"></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="showCalc">
                        <value-box :white-mode="whiteMode" :value="calcR2" unit="" :title="'R²'|translate" :decimals="4"></value-box>
                    </v-flex>
                    <v-flex xs12 v-if="ecMode">
                        <v-switch color="success"  :label="'Monthly Savings'|translate" v-model="ecMonthly" v-if="ecConfig3"></v-switch>
                        <v-switch color="success"  :label="'Summary'|translate" v-model="ecSummary"></v-switch>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {callAPI,findLineByLeastSquares} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    import moment from 'moment'
    import ValueBox from "./../ValueBox";
    import VueEchart from "@/components/VueEchart";
    import data3Processor from "../mixins/data3Processor";
    export default {
        props: {
            customInterpolation:{type: String, default: null},
            interpolation:{type: String, default: "linear"},
            parameters: {type: Object, default: null},
            powerSensor:{type: String, default: "Power"},
            weatherSensor:{type: String, default: "Weather - Outdoor_Temperature"},
            weatherTitle:{type: String, default: "Average outdoor air temperature (°C)"},
            title:{type: String, default: "Energy consumption vs OAT"},
            startDate:{type: String, default: null},
            endDate:{type: String, default: null},
            cutOff:{type: String, default: null},
            useSwitch:{type: Boolean, default: false},
            switchSensor:{type: String, default: "Header - Switch_Optimization"},
            minTemp:{type: Number, default: 20},
            maxTemp:{type: Number, default: 35},
            resamplingFactor:{type: Number, default: null},
            showNegativeMonthly: {type: Boolean, default: false},
            dateRange: {type: Object, default: null},
            hideKpi: {type: Boolean, default: false},
            whiteMode:{type:Boolean, default: false},
            ecMode:{type:Boolean, default: false},
            showCalc:{type:Boolean, default: false},
            data3query: {
                type: Object, default: function () {
                    return {
                        "layout-overrides": {
                            "title": "",
                            "showlegend": false,
                            "height": 300,
                            "margin": {
                                "l": 50,
                                "r": 50,
                                "b": 0,
                                "t": 0,
                                "pad": 1
                            },
                            "xaxis": {
                                "title": ""
                            },
                            "yaxis": {
                                "title": ""
                            },
                            "zaxis": {
                                "title": null
                            }
                        },
                        "x-axis": "timestamp",
                        "y-axis": null,
                        "independent-x": false,
                        "color-axis": null,
                        "marker-size-axis": null,
                        "color-axis-scale": null,
                        "color-axis-title": null,
                        "data-payload": [
                            {
                                "filters": {
                                    "sensor_name": "Power"
                                },
                                "seriesOverrides": {
                                    "type": "table",
                                    "opacity": 1,
                                    "xbins": {
                                        "size": 1
                                    },
                                    "ybins": {
                                        "size": 1
                                    }
                                },
                                "pipeline": [
                                    {
                                        "type": "agg_h",
                                        "agg_op": "sum",
                                        "name": "Power"
                                    }
                                ],
                                "offsetRange": false,
                                "offsetType": "months",
                                "offsetAmount": 1
                            },
                            {
                                "filters": {
                                    "sensor_name": "Outdoor_Temperature",
                                    "equipment_name": "Weather"
                                },
                                "seriesOverrides": {
                                    "type": "table",
                                    "opacity": 1,
                                    "xbins": {
                                        "size": 1
                                    },
                                    "ybins": {
                                        "size": 1
                                    }
                                },
                                "pipeline": [],
                                "offsetRange": false,
                                "offsetType": "months",
                                "offsetAmount": 1
                            }
                        ]
                    }
                }
            },
        },
        components: {LoadingProgressBar,VuePlotly,ValueBox,VueEchart},
        mixins: [data3Processor],
        computed: {
            ecConfig(){
                if (this.ecSummary&&this.ecConfig2){
                    return this.ecConfig2
                } else if (this.ecMonthly&&this.ecConfig3){
                    return this.ecConfig3
                } else {
                    return this.ecConfig1
                }
            },
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            },
            layout(){return{
                title:this.title,
                hovermode: 'closest',
                xaxis: {
                    title:this.weatherTitle,
                    range:this.xRange
                },
                yaxis: {
                    title: 'Total energy consumption (kWh)',
                    rangemode:'tozero',
                },
                margin:{
                    l: 70,
                    r: 70,
                    t: 30,
                    pad: 1
                },
                hoverlabel: {
                    namelength: -1
                },
                showlegend:true,
                legend: {
                    orientation: 'h',
                    y:-0.2,
                },
            }},
        },
        name: 'FlexibleOptimizationWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
            parameters:{
                handler() {
                    this.refresh()
                },
                deep: true,
                immediate: true,
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                reloadInc:0,
                totalSavingSum:0,
                totalPowerSum:0,
                xRange:null,
                ecConfig1:null,
                ecConfig2:null,
                ecConfig3:null,
                ecSummary:false,
                ecMonthly:false,
                calcEquation:null,
                calcR2:null,

            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => callback(), wait);
            },
            refresh() {
                this.debounce(this.getData, 500);
            },
            rSquared(x, y, coefficients) {
                let regressionSquaredError = 0
                let totalSquaredError = 0

                function yPrediction(x, coefficients) {
                    return coefficients[1] + coefficients[0] * x
                }
                let yMean = y.reduce((a, b) => a + b) / y.length
                for (let i = 0; i < x.length; i++) {
                    regressionSquaredError += Math.pow(y[i] - yPrediction(x[i], coefficients), 2)
                    totalSquaredError += Math.pow(y[i] - yMean, 2)
                }
                return 1 - (regressionSquaredError / totalSquaredError)
            },
            getData() {
                let me = this
                me.loading = true
                this.ecConfig2=null
                this.ecConfig3=null
                this.reloadInc=this.reloadInc+1
                let currentInc=this.reloadInc
                let dateRange=this.dateRange ? [this.dateRange.start,this.dateRange.end.length<12 ? this.dateRange.end+" 23:59:59": this.dateRange.end] : null;
                if (this.startDate&&this.endDate){
                    dateRange=[moment(this.startDate).format('YYYY-MM-DD'),moment(this.endDate).format('YYYY-MM-DD')+" 23:59:59"]
                } else if (this.startDate){
                    let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                    let endDate=moment()
                    if(maxDate){
                        endDate=moment(maxDate)
                    }
                    dateRange=[moment(this.startDate).format('YYYY-MM-DD'),moment(endDate).format('YYYY-MM-DD')+" 23:59:59"]
                }
                let payloadArray=JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray=payloadArray.filter(x=>x.filters&&(x.filters.sensor_name||x.filters.equipment_name))
                for (let payload of payloadArray){
                    payload.parameters=this.parameters
                    this.processDateRange(payload, {start: dateRange[0], end: dateRange[1]})
                    if(!payload.filters.facility_name&&this.$store.state.pointsListStore.pointsList.facility_name){
                        payload.filters.facility_name=this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if(payload.onOnly){
                        if(!payload.pipeline){
                            payload.pipeline=[]
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let promises=payloadArray.map(payload=>callAPI('data3/',payload))
                Promise.all(promises).then(function(results) {
                    if (currentInc!==me.reloadInc){
                        return
                    }
                    let Timestamp=null;
                    let Power=null;
                    let OAT=null;
                    let Switch=null;
                    for (let result of results){
                        if(!Timestamp&&result.data.timestamp){
                            Timestamp=result.data.timestamp
                        }
                        if(result.data[me.powerSensor]){
                            Power=result.data[me.powerSensor]
                        }
                        if(result.data[me.weatherSensor]){
                            OAT=result.data[me.weatherSensor]
                        }
                        if(result.data[me.switchSensor]){
                            Switch=result.data[me.switchSensor]
                        }
                    }
                    let prePower = [];
                    let postPower = [];
                    let preLabels = [];
                    let postLabels = [];
                    let preOAT=[];
                    let postOAT=[];
                    let ecPreData=[]
                    let ecPostData=[]
                    let ecInterpData=[]
                    let cutOff=me.cutOff ? moment(me.cutOff).format('YYYY-MM-DD HH:mm:ss') : null
                    for (let index in Timestamp){
                        if(!Power[index]||!OAT[index]||(me.useSwitch&&Switch[index]===null)){
                            continue;
                        }
                        if((!me.cutOff&&me.useSwitch&&Switch[index]>0.5)||(me.cutOff&&Timestamp[index]>=cutOff&&(!me.useSwitch||Switch[index]>0.5))){
                            postPower.push(Power[index])
                            postOAT.push(OAT[index])
                            postLabels.push(Timestamp[index])
                            ecPostData.push({name:Timestamp[index],value:[OAT[index],Power[index]]})
                        } else {
                            prePower.push(Power[index])
                            preOAT.push(OAT[index])
                            preLabels.push(Timestamp[index])
                            ecPreData.push({name:Timestamp[index],value:[OAT[index],Power[index]]})
                        }
                    }
                    let getY=null
                    if(me.interpolation==="custom"&&me.customInterpolation){
                        getY=eval(me.customInterpolation)
                    } else {
                        let trendBeforeCurb=findLineByLeastSquares(preOAT,prePower)
                        getY=function(x){
                            return ((x*trendBeforeCurb[0])+trendBeforeCurb[1])
                        }
                        if (me.showCalc){
                            me.calcEquation=trendBeforeCurb[1]>=0 ?  "Y = X*"+trendBeforeCurb[0].toFixed(2)+" + "+trendBeforeCurb[1].toFixed(2) : "Y = X*"+trendBeforeCurb[0].toFixed(2)+" "+trendBeforeCurb[1].toFixed(2)
                            me.calcR2=me.rSquared(preOAT,prePower,trendBeforeCurb)
                        }
                    }
                    let preInterpolatedPower=[]
                    let preInterpolatedTemp=[]
                    let increm=parseFloat((me.maxTemp-me.minTemp)/1000)
                    for (let i=me.minTemp; i<=me.maxTemp; i=i+increm){
                        preInterpolatedPower.push(getY(i))
                        preInterpolatedTemp.push(i)
                        ecInterpData.push([i,getY(i)])
                    }
                    let data = [
                        {
                            x: me.resamplingFactor ? preOAT.filter((element, index) => index % me.resamplingFactor === 0) : preOAT,
                            y: me.resamplingFactor ? prePower.filter((element, index) => index % me.resamplingFactor === 0) : prePower,
                            type: 'scattergl',
                            mode: 'markers',
                            name: "Before optimisation",
                            hovertext: me.resamplingFactor ? preLabels.filter((element, index) => index % me.resamplingFactor === 0) : preLabels,
                            marker: {
                                color: 'rgb(31, 119, 180)',
                            }
                        },
                        {
                            x: preInterpolatedTemp,
                            y: preInterpolatedPower,
                            type: 'scattergl',
                            name:"Before optimisation trend",
                            mode: 'lines',
                            line: {
                                color: 'rgb(31, 119, 180)',
                                width: 2,
                                dash:'dot'
                            }
                        },
                    ]
                    let ecConfig1={
                        title : {
                            text:me.title,
                            left:'center'
                        },
                        tooltip: {
                            position: 'top',
                            formatter: function (params) {
                                return (
                                    params.seriesName +
                                    ' <br/>' +
                                    params.name +
                                    ' <br/>' +
                                    params.value[0].toLocaleString() +
                                    '°C ' +
                                    params.value[1].toLocaleString()  +
                                    'kWh '
                                );
                            },
                        },
                        xAxis: {
                            min: me.minTemp,
                            max: me.maxTemp,
                            name:me.weatherTitle,
                            nameLocation: 'middle',
                            nameGap: 25
                        },
                        yAxis: {
                            scale: true,
                            name:'Total energy consumption (kWh)',
                            nameLocation: 'middle',
                            nameGap: 50
                        },
                        legend: {
                            bottom: 10,
                            left: 'center',
                        },
                        series: [
                            {
                                type: 'scatter',
                                symbolSize: 6,
                                id: 'bms',
                                name:'Before optimisation',
                                dataGroupId: 'bms',
                                universalTransition: {
                                    enabled: true,
                                    delay: function (idx, count) {
                                        return Math.random() * 400;
                                    }
                                },
                                data: me.resamplingFactor ? ecPreData.filter((element, index) => index % me.resamplingFactor === 0) : ecPreData,
                                itemStyle: {
                                    color: 'rgb(31, 119, 180)'
                                }
                            },
                            {
                                type: 'line',
                                showSymbol: false,
                                name:'Before optimisation trend',
                                data: ecInterpData,
                                lineStyle: {
                                    type : 'dashed',
                                    color: 'rgb(31, 119, 180)'
                                },
                                itemStyle: {
                                    color: 'rgb(31, 119, 180)'
                                }
                            },

                        ]
                    }
                    let ecConfig2={
                        xAxis: {
                            type: 'category',
                            data: ['Before optimisation']
                        },
                        yAxis: {},
                        title : {
                            text:'Total energy consumption (kWh)',
                            left:'center'
                        },
                        series: [
                            {
                                type: 'bar',
                                id: 'total',
                                data: [
                                    {
                                        value: prePower.reduce((sum, x) => sum + x),
                                        groupId: 'bms',
                                        itemStyle: {
                                            color: 'rgb(31, 119, 180)'
                                        }
                                    },
                                ],
                                label: {
                                    show: true,
                                    position: 'top',
                                    formatter: function(d) {
                                        return d.value.toLocaleString() + " kWh";
                                    }
                                },
                                universalTransition: {
                                    enabled: true,
                                    seriesKey: ['bms'],
                                    delay: function (idx, count) {
                                        return Math.random() * 400;
                                    }
                                }
                            }
                        ]
                    }
                    if(postOAT.length>0){
                        let totalPowerSum=0
                        let totalSavingSum=0
                        let monthlyDataAgg={}
                        for (let k in postOAT){
                            totalPowerSum+=postPower[k];
                            totalSavingSum+=getY(postOAT[k])-postPower[k];
                            let formatedMonth=moment(postLabels[k]).format("MMM YY")
                            if (!monthlyDataAgg[formatedMonth]){
                                monthlyDataAgg[formatedMonth]={
                                    time:formatedMonth,
                                    saving:0,
                                }
                            }
                            monthlyDataAgg[formatedMonth].saving=monthlyDataAgg[formatedMonth].saving+getY(postOAT[k])-postPower[k];
                        }
                        me.totalPowerSum=totalPowerSum;
                        me.totalSavingSum=totalSavingSum;
                        let monthlyData=Object.values(monthlyDataAgg)
                        data.push({
                            x: me.resamplingFactor ? postOAT.filter((element, index) => index % me.resamplingFactor === 0) : postOAT,
                            y: me.resamplingFactor ? postPower.filter((element, index) => index % me.resamplingFactor === 0) : postPower,
                            type: 'scattergl',
                            mode: 'markers',
                            name: "After optimisation",
                            hovertext: me.resamplingFactor ? postLabels.filter((element, index) => index % me.resamplingFactor === 0) : postLabels,
                            marker: {
                                color: 'rgb(255, 127, 14)',
                            }
                        })
                        ecConfig2.series[0].data[0].value=me.totalPowerSum+me.totalSavingSum
                        ecConfig2.series[0].data.push({
                            value: me.totalPowerSum,
                            groupId: 'opti',
                            itemStyle: {
                                color: 'rgb(255, 127, 14)'
                            }
                        })
                        ecConfig2.series[0].universalTransition.seriesKey.push('opti')
                        ecConfig2.xAxis.data.push('After Optimization')
                        ecConfig1.series.push({
                            type: 'scatter',
                            symbolSize: 6,
                            id: 'opti',
                            name:'After Optimization',
                            dataGroupId: 'opti',
                            universalTransition: {
                                enabled: true,
                                delay: function (idx, count) {
                                    return Math.random() * 400;
                                }
                            },
                            data: me.resamplingFactor ? ecPostData.filter((element, index) => index % me.resamplingFactor === 0) : ecPostData,
                            itemStyle: {
                                color: 'rgb(255, 127, 14)'
                            }
                        })
                        me.ecConfig3={
                            title : {
                                text:me.title,
                                left:'center'
                            },
                            xAxis: {
                                type: 'category',
                                data: monthlyData.map(x=>x.time),
                            },
                            yAxis: {
                                scale: true,
                                name:'Energy Savings (kWh)',
                                nameLocation: 'middle',
                                nameGap: 50
                            },
                            legend: false,
                            series: [
                                {
                                    type: 'bar',
                                    id: 'opti',
                                    name:'Savings',
                                    dataGroupId: 'opti',
                                    universalTransition: {
                                        enabled: true,
                                        seriesKey: ['opti'],
                                        delay: function (idx, count) {
                                            return Math.random() * 400;
                                        }
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: function(d) {
                                            return d.value.toLocaleString() + " kWh";
                                        }
                                    },
                                    data: me.showNegativeMonthly ? monthlyData.map(x=>x.saving) : monthlyData.map(x=>Math.max(x.saving,0)),
                                    itemStyle: {
                                        color: 'rgb(255, 127, 14)'
                                    }
                                },
                            ]
                        }
                    }
                    me.data=data
                    me.xRange=[me.minTemp,me.maxTemp]
                    me.ecConfig1=ecConfig1
                    me.ecConfig2=ecConfig2
                    me.loading=false
                })
            }
        },
    }

</script>

<style scoped>

</style>
